import { useSelector } from 'react-redux';
import { commonConfigurationSelector } from '../../../redux/reducers/app/configuration';

// TODO: temporary hooks only for making requests to Meta tags
export const useIsEnabledLanguageInRequests = () => {
  const commonConfig = useSelector(commonConfigurationSelector);
  return commonConfig?.isMetaTagsTranslates || false;
};
